import React, { Fragment, useState, useEffect } from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import IconButton from '@material-ui/core/IconButton';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Button } from 'reactstrap'
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faCheck, faExclamation } from "@fortawesome/free-solid-svg-icons";
import AlertModal from '../../../shared/components/Modal';
import Tooltip from '@material-ui/core/Tooltip';
import ModalServiceFee from './ModalServiceFee';
import ExceptionsModal from './ExceptionsModal';

const ListFeesActions = ({ data, profesional, updateFee,thirds }) => {

    const [modalServiceFeeOpened, setModalServiceFeeOpened] = useState(null);
    const [modalExceptionOpened, setModalExceptionOpened] = useState(null);

    useEffect(() => {

    }, []);

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Editar Honorario">
                <IconButton style={{ fontSize: '15px' }} onClick={() => setModalServiceFeeOpened(true)}>
                    <FontAwesomeIcon icon={faEdit} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Excepciones">
                <IconButton style={{ fontSize: '15px' }} onClick={() => setModalExceptionOpened(true)}>
                    <FontAwesomeIcon icon={faExclamation} />
                </IconButton>
            </Tooltip>



        </td>

        <ModalServiceFee
            opened={modalServiceFeeOpened}
            service={data.data.original}
            doCloseModalServiceFee={() => setModalServiceFeeOpened(false)}
            profesional={profesional}
            updateFee={updateFee}
        />

        <ExceptionsModal
            opened={modalExceptionOpened}
            service={data.data.original}
            doCloseModalExceptions={() => setModalExceptionOpened(false)}
            profesional={profesional}
            thirds={thirds}
        />

    </Fragment>)
}

export default ListFeesActions;